import ROUTES from '@/shared/constants/routes';

/** Alias local de las rutas del flujo, para no repetir el import de ROUTES en cada vista. */
export const INVOICE_V2_ROUTES = {
  HOME: ROUTES.FACTURACION,
  STAMPS: ROUTES.FACTURACION_STAMPS,
  PLANS: ROUTES.FACTURACION_PLANES,
  NEW_CLIENT: ROUTES.FACTURACION_NEW_CLIENT,
  CONCEPTS: ROUTES.FACTURACION_CONCEPTS,
  PAYMENT: ROUTES.FACTURACION_PAYMENT,
  REVIEW: ROUTES.FACTURACION_REVIEW,
  QR_CONFIG: ROUTES.FACTURACION_QR,
  QR_REQUESTS: ROUTES.FACTURACION_QR_REQUESTS,
  PDF_BRAND: ROUTES.FACTURACION_MARCA,
  PAYMENT_COMPLEMENT: ROUTES.FACTURACION_COMPLEMENTO,
  PAYMENT_COMPLEMENT_DATA: ROUTES.FACTURACION_COMPLEMENTO_PAGO,
  PAYMENT_COMPLEMENT_REVIEW: ROUTES.FACTURACION_COMPLEMENTO_REVISAR,
  PAYMENT_COMPLEMENT_DONE: ROUTES.FACTURACION_COMPLEMENTO_LISTO,
} as const;

export const stampedInvoicePath = (folio: string) => `/facturacion/f/${folio}`;

export const qrRequestPath = (id: number) => `${ROUTES.FACTURACION_QR_REQUESTS}/${id}`;

/** El estado con el que se abre una solicitud: su flecha regresa a `from` (su página o el listado, con su `?periodo=`). */
export interface QrRequestLinkState {
  from: string;
}
